import {ResourceOptions} from 'react-admin'
import {FaUserShield} from 'react-icons/fa'
import {Resources} from '../resource'

export {default as list} from './List'

export const name = Resources.userRole
export const icon = FaUserShield
export const options: ResourceOptions = {
  label: 'resource.userRole',
}

